import { buildApiUrl, buildHeaders, handleResponse } from '@/network/api-client';
import type {
  CharacterApi,
  CharacterSnapshot,
  AdviceResponse,
} from '../types/character.types';
export const characterApi: CharacterApi = {
async journal(signal) { return handleResponse(await fetch(buildApiUrl('/hero/character/journal'), {headers: buildHeaders(),signal,cache:"no-store"})); },
  async snapshot(signal) {
    return handleResponse<CharacterSnapshot>(
      await fetch(buildApiUrl('/hero/character'), {
        headers: buildHeaders(),
        signal,
      }),
    );
  },
  async advise(command, signal) {
    return handleResponse<AdviceResponse>(
      await fetch(buildApiUrl('/hero/character/advice'), {
        method: 'POST',
        headers: buildHeaders(),
        body: JSON.stringify(command),
        signal,
      }),
    );
  },
};
